import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Auth } from '../services/auth';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(Auth);

  return next(req).pipe(
    catchError(error => {
      // Check for authentication errors (401 Unauthorized or 403 Forbidden)
      if (error.status === 401 || error.status === 403) {
        // Skip logout for the login endpoints (no session yet): the base login
        // and the staged-login 2FA completion step handle their own errors.
        // The 2FA management endpoints (/rest/2fa/*) are also exempt: the
        // backend answers 422 for a bad code, but a 401/403 slipping through
        // (proxy rewrite, future BE change) must not log the user out mid-setup.
        if (
          !req.url.includes('/login') &&
          !req.url.includes('/rest/auth/2fa/') &&
          !req.url.includes('/rest/2fa/')
        ) {
          authService.logoutLocally();
        }
      }
      return throwError(() => error);
    })
  );
};